
























import router from "@/router";
import { Sidebar, Navbar } from "@micad/vue-components";
import {
  defineComponent,
  reactive,
  computed,
  watch,
  nextTick,
} from "@vue/composition-api";
import { getClientInfo, getApps, AppOption } from "@/data/repos/userInfo";
import config from "@/config";
import { authzFlags, fetchUserInfo, canIUse } from "@/modules/auth";
import { getClients } from "@/data/repos/client";
import { getClientConfigValue } from "@/data/repos/clientConfig";
import { switchClient } from "@/modules/utils";

interface NavBarLink {
  path?: string;
  url?: string;
  title: string;
  name: string;
  iconName: string;
}
export default defineComponent({
  components: {
    Navbar,
    Sidebar,
  },
  setup(_, ctx) {
    const state = reactive({
      authUser: {
        userName: "User name",
        userRole: "",
      },
      userDropdownOptions: [
        {
          label: "My Details",
          onClick: async () => router.push({ name: "UserDetails" }),
        },
        {
          label: "Sign out",
          onClick: async () =>
            router.push({
              name: "Logout",
              query: { status: "UserLogout" },
            }),
        },
      ] as { label: string; onClick: () => void }[],
      logoUrl: "/",
      logoSrc: require("@/assets/images/sams.png"),
      clientLogoSrc: "",
      orgLogoSrc: "",
      apps: [] as AppOption[],
      links: [] as NavBarLink[],
      currentRoute: computed(() => ctx.root.$route.name),
      showProfiles: false,
    });

    getClientConfigValue("HIDE_USER_PROFILES").then((resp) => {
      state.showProfiles =
        (resp.payload?.value || "").toLocaleLowerCase() !== "y";
      authzFlags.push("");
      nextTick(() => authzFlags.pop());
    });
    watch(
      () => authzFlags,
      () => {
        state.links.splice(0, state.links.length);
        state.links.push(
          ...[
            {
              path: "/user",
              title: "Me",
              name: "Users",
              iconName: "user-check",
            },
            ...(canIUse("Users_r")
              ? [
                  {
                    path: "/",
                    title: "Users",
                    name: "Home",
                    iconName: "users",
                  },
                ]
              : []),
            ...(canIUse("UserProfiles_r") && state.showProfiles
              ? [
                  {
                    title: "User Profiles",
                    path: "/user-profiles",
                    name: "UserProfiles",
                    iconName: "users",
                  },
                ]
              : []),
            ...(canIUse("Connections_r")
              ? [
                  {
                    title: "Connections",
                    path: "/connections",
                    name: "Connections",
                    iconName: "wifi",
                  },
                ]
              : []),
            ...(canIUse("Licences_r")
              ? [
                  {
                    title: "Licences",
                    path: "/licences",
                    name: "Licences",
                    iconName: "award",
                  },
                ]
              : []),
            ...(canIUse("Branding_r")
              ? [
                  {
                    title: "Branding",
                    path: "/branding",
                    name: "Branding",
                    iconName: "edit",
                  },
                ]
              : []),
            ...(canIUse("Terms_r")
              ? [
                  {
                    title: "Terms & Conditions",
                    path: "/terms",
                    name: "Terms",
                    iconName: "lock",
                  },
                ]
              : []),
            ...(canIUse("Notifications_r")
              ? [
                  {
                    title: "Notifications",
                    path: "/notifications",
                    name: "Notifications",
                    iconName: "bell",
                  },
                ]
              : []),
            ...(canIUse("Clients_r")
              ? [
                  {
                    path: "/clients",
                    title: "Clients",
                    name: "Clients",
                    iconName: "users",
                  },
                ]
              : []),
            // {
            //   title: "Settings",
            //   path: "/settings",
            //   name: "Settings",
            //   iconName: "settings",
            // },
            ...(config.USER_REPORTS_URL
              ? [
                  {
                    title: "User reports",
                    url: config.USER_REPORTS_URL,
                    name: "UserReports",
                    iconName: "users",
                  },
                ]
              : []),
          ]
        );
      },
      // immediate: flags may already be loaded by the router guard before mount
      { deep: true, immediate: true }
    );
    setTimeout(async () => {
      const us = await fetchUserInfo();
      const ci = await getClientInfo();
      const myRole = us.myRole;
      state.authUser.userName = `${us.firstName} ${us.lastName}`;
      state.authUser.userRole = `${myRole} [${ci.name}]`;
      // state.clientLogoSrc = ci.logoUrl;
      state.logoSrc = `${window.location.origin}/api/brandingImage?clientKey=${ci.key}&kind=login&id=0`;
      state.orgLogoSrc = `${window.location.origin}/api/brandingImage?clientKey=${ci.key}&kind=login&id=1`;
      state.clientLogoSrc = `${window.location.origin}/api/brandingImage?clientKey=${ci.key}&kind=login&id=2`;

      const appsResponse = await getApps();
      getClients({ includeChildren: true, hideInactive: true }).then((resp) => {
        const item = {
          label: "Switch client",
          onClick: async () => switchClient(),
        };
        if (!(resp.ok && resp.payload && resp.payload.length === 1))
          state.userDropdownOptions.splice(0, 0, item);
      });

      if (appsResponse.applications?.length) {
        state.apps = appsResponse.applications;

        const hub = state.apps.find((app) => app.app == "Hub");
        if (hub && hub.homeUrl) {
          state.logoUrl = hub.homeUrl;
        }
      }
    }, 0);
    return { state };
  },
});
